/* Shopify path: assets/pro-tabs-showcase.js */

(() => {
  const MODULE_KEY = '__proTabsShowcaseEditorV1';
  if (window[MODULE_KEY]) return;
  window[MODULE_KEY] = true;

  const findSelectedTab = (event) => {
    const directTab = event.target instanceof Element
      ? event.target.closest('[data-pts-tab]')
      : null;

    if (directTab) return directTab;

    const section = event.target instanceof Element
      ? event.target.closest('[data-pro-tabs-showcase]') || event.target.querySelector?.('[data-pro-tabs-showcase]')
      : null;

    const blockId = event.detail?.blockId;
    if (!section || !blockId) return null;

    return Array.from(section.querySelectorAll('[data-pts-tab]')).find(
      (tab) => tab.dataset.ptsBlockId === blockId
    ) || null;
  };

  document.addEventListener('shopify:block:select', (event) => {
    const selectedTab = findSelectedTab(event);
    if (!selectedTab) return;

    const accordion = selectedTab.parentElement;
    if (!accordion?.matches('[data-pro-collapsible-content]')) return;

    Array.from(accordion.children).forEach((item) => {
      if (item !== selectedTab && item instanceof HTMLDetailsElement && item.open) {
        item.open = false;
      }
    });

    selectedTab.open = true;
  });
})();
